import { Plus, Download } from 'lucide-react';

interface UsersPageHeaderActionsProps {
  /** Label suffix on the Invite button, e.g. "Invite user to PNW". */
  inviteLabel: string;
  /** Whether the API lets the viewer invite; the button is absent otherwise. */
  canInvite: boolean;
  /** Open the invite drawer. */
  onInvite: () => void;
}

/** Right-side action buttons for the Users page — Export (stubbed) +
 *  Invite. The page title + breadcrumb live in {@link SettingsPageShell};
 *  this component fills the shell's `actions` slot. */
export default function UsersPageHeaderActions({
  inviteLabel,
  canInvite,
  onInvite,
}: UsersPageHeaderActionsProps) {
  return (
    <>
      <button
        type="button"
        disabled
        title="Export ships with the audit-log PR"
        className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg text-[13px] font-semibold text-stone-400 dark:text-stone-500 cursor-not-allowed"
      >
        <Download size={13} />
        Export
      </button>
      {canInvite && (
        <button
          type="button"
          onClick={onInvite}
          className="inline-flex items-center gap-1.5 h-8 px-3.5 rounded-lg text-[13px] font-semibold text-white bg-moss-600 hover:bg-moss-700"
        >
          <Plus size={13} />
          {inviteLabel}
        </button>
      )}
    </>
  );
}
